import {
  ParagraphText,
  TextAction,
  type GDSStyleObject,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { APP_NAME, EXTERNAL_URLS } from 'common/constants/constants';
import { ExternalLink } from 'components/external-link/external-link.component';

type TextCommunicationConsentTextProps = {
  css?: GDSStyleObject;
};

export const TextCommunicationConsentText = ({
  css,
}: TextCommunicationConsentTextProps) => {
  const { formatMessage } = useIntl();

  return (
    <ParagraphText
      css={{
        '& > a': {
          textDecoration: 'underline',
        },
        ...{ ...css },
      }}
    >
      {formatMessage(
        {
          id: 'STR_TEXT_MESSAGE_CONSENT',
        },
        {
          appName: APP_NAME,
          termsAndConditionsLink: (
            <TextAction
              as={ExternalLink}
              href={EXTERNAL_URLS.TERMS_OF_USE}
              css={{ display: 'inline' }}
            >
              {formatMessage({ id: 'STR_TERMS_AND_CONDITIONS' })}
            </TextAction>
          ),
          privacyPolicyLink: (
            <TextAction
              as={ExternalLink}
              href={EXTERNAL_URLS.PRIVACY_POLICY}
              css={{ display: 'inline' }}
            >
              {formatMessage({ id: 'STR_PRIVACY_POLICY' })}
            </TextAction>
          ),
          noticeOfPrivacyPracticesLink: (
            <TextAction
              as={ExternalLink}
              href={EXTERNAL_URLS.NOTICE_OF_PRIVACY_PRACTICES}
              css={{ display: 'inline' }}
            >
              {formatMessage({ id: 'STR_NOTICE_OF_PRIVACY_PRACTICES' })}
            </TextAction>
          ),
        },
      )}
    </ParagraphText>
  );
};
